import getMlsThreshold from '../../../../utils/get-mls-threshold';

const getPrefixSentence = ({ income }: { income: number }, thresholds: any) => {
  const matchedThreshold = getMlsThreshold({ income, thresholds });
  const rate = matchedThreshold?.rate ?? 0;
  if (rate === 0) return null;

  return `${rate}% MLS applying to`;
};

export default getPrefixSentence;
